// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import PasswordVisibility from "@stimulus-components/password-visibility"
application.register("password-visibility", PasswordVisibility)

import TextareaAutogrow from "stimulus-textarea-autogrow"
application.register("textarea-autogrow", TextareaAutogrow)

import BenefitsManagerController from "./benefits_manager_controller"
application.register("benefits-manager", BenefitsManagerController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DivisionsController from "./divisions_controller"
application.register("divisions", DivisionsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import MultiImageUploadController from "./multi_image_upload_controller"
application.register("multi-image-upload", MultiImageUploadController)

import ReportPhotosController from "./report_photos_controller"
application.register("report-photos", ReportPhotosController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ParticipantSelectionController from "./participant_selection_controller"
application.register("participant-selection", ParticipantSelectionController)

import RegistrationRosterController from "./registration_roster_controller"
application.register("registration-roster", RegistrationRosterController)

import ScoringRuleFormController from "./scoring_rule_form_controller"
application.register("scoring-rule-form", ScoringRuleFormController)

import ScoringRulesIndexController from "./scoring_rules_index_controller"
application.register("scoring-rules-index", ScoringRulesIndexController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import RoleFieldsController from "./role_fields_controller"
application.register("role-fields", RoleFieldsController)

import MirrorFieldController from "./mirror_field_controller"
application.register("mirror-field", MirrorFieldController)

import OnboardingReviewController from "./onboarding_review_controller"
application.register("onboarding-review", OnboardingReviewController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import UserSearchController from "./user_search_controller"
application.register("user-search", UserSearchController)

import SpeciesMultiselectController from "./species_multiselect_controller"
application.register("species-multiselect", SpeciesMultiselectController)
